import PropTypes from 'prop-types';

function IFDairyAndEggsInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M10.5823 3.78418L7.48676 7.34368L12.0932 8.34543L14.4949 4.63403L10.5823 3.78418Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.48675 7.34375C7.48675 7.34375 3.13488 26.1266 3.28678 26.3524C3.38532 26.4961 4.46918 26.763 5.51199 27.1735C6.38647 27.5225 7.70435 27.8756 7.70435 27.8756L12.0932 8.36192L7.48675 7.34375Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.0932 8.3623C12.0932 8.3623 18.5635 9.59397 18.6621 9.78693C18.7606 9.97989 15.0697 27.9293 15.0328 28.1058C14.9301 28.6149 14.7454 28.8941 13.2387 28.7586C11.3811 28.5727 9.53504 28.2862 7.7085 27.9006L12.0932 8.3623Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.0931 8.36198L14.4949 4.66699C14.4949 4.66699 17.0362 5.12681 17.3688 5.29103C17.7013 5.45526 18.662 9.80713 18.662 9.80713L12.0931 8.36198Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.1466 4.08409C12.2205 3.75975 12.4668 2.65125 12.4668 2.65125C12.4668 2.65125 12.5818 1.89994 13.0704 2.01489L15.4803 2.5363C15.4803 2.5363 16.2768 2.64304 16.1782 3.09876C16.0797 3.55447 15.7677 4.88056 15.7677 4.88056L12.1466 4.08409Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.0231 26.3815C13.8365 24.6353 14.5288 18.3528 17.0231 17.694C20.3356 16.819 23.4223 21.6097 22.2105 24.5065C21.4262 26.3815 18.9222 27.4222 17.0231 26.3815Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
            />
            <path
                d="M19.1296 21.6169C17.5434 18.3478 21.7467 13.6274 24.1615 14.5351C27.3686 15.7404 27.1099 21.4336 24.4443 23.0931C22.7189 24.1673 20.0749 23.5653 19.1296 21.6169Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
            />
        </svg>
    );
}

export default IFDairyAndEggsInactive;

IFDairyAndEggsInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

IFDairyAndEggsInactive.defaultProps = {
    className: null,
};
